import React from "react"
import { BiImport } from "react-icons/bi"
import { type Props } from "./_types"
const IconImport: React.FC<Props> = ({ size = 15, color = "#fff" }): React.ReactElement => {
  return <BiImport size={size} color={color} />
}

export default IconImport
